import "./App.css";
import Routers from "./Routers";

const App = () => {
  return <Routers />;
};

export default App;
